import React from "react";
import { useTranslation } from "react-i18next";
import Icon from "../../components/Icon";

export default function ErrorMapView({ errors, revealedCount }) {
    const { t } = useTranslation();
    const visible = errors.slice(0, revealedCount);

    return (
        <div className="space-y-3">
            <div className="flex items-center gap-2">
                <Icon name="Shield" className="w-4 h-4 text-blue-600" />
                <h3 className="text-sm font-semibold text-gray-700">{t("builder.errorMap.title")}</h3>
                <span className="text-xs text-gray-400">{visible.length} / {errors.length}</span>
            </div>
            <div className="space-y-2">
                {visible.map((err, i) => {
                    const isNew = i === revealedCount - 1;
                    return (
                        <div
                            key={err.code}
                            className={`bg-white border rounded-lg p-3 space-y-1.5 ${isNew ? "animate-in fade-in slide-in-from-right-4 duration-500 ring-2 ring-blue-200" : ""}`}
                        >
                            <div className="flex items-center gap-2">
                                <span className="text-xs font-bold px-1.5 py-0.5 rounded bg-gray-100 text-gray-600 font-mono">{err.status}</span>
                                <span className="text-xs font-semibold text-gray-800">{err.code}</span>
                            </div>
                            <p className="text-xs text-gray-600">{err.message}</p>
                            <p className="text-[10px] text-blue-600 flex items-center gap-1">
                                <Icon name="Lightbulb" className="w-3 h-3" /> {err.solution}
                            </p>
                        </div>
                    );
                })}
            </div>
            {revealedCount < errors.length && (
                <div className="flex items-center gap-2 text-blue-500 text-xs animate-pulse">
                    <Icon name="Loader" className="w-3 h-3 animate-spin" />
                    <span>{t("builder.errorMap.generating")}</span>
                </div>
            )}
        </div>
    );
}
